export default __webpack_public_path__ + "static/media/Services-5.f4e0aa32.jpg";